import DetailReception from './DetailReception.jsx';
export {
    DetailReception
};



// WEBPACK FOOTER //
// ./src/components/modules/reception/detail-reception/index.js